import { render, staticRenderFns } from "./AmountUnit.vue?vue&type=template&id=252f7968&scoped=true"
import script from "./AmountUnit.vue?vue&type=script&lang=js"
export * from "./AmountUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f7968",
  null
  
)

export default component.exports